<div class="facility-dialog-container">
  <!-- Header -->
  <h2 mat-dialog-title>{{ dialogTitle }}</h2>

  @if (showAgreementView) {
  <div class="agreement-view">
    <mat-dialog-content class="dialog-content">
      <div class="facility-data-readonly">
        <h3>Facility Information</h3>
        <div class="data-grid">
          <div class="data-row">
            <label>Facility Name:</label>
            <span>{{ facilityData.facilityName }}</span>
          </div>
          @if (facilityData.facilityId !== 'To be assigned') {
          <div class="data-row">
            <label>Facility ID:</label>
            <span>{{ facilityData.facilityId }}</span>
          </div>
          }
          <div class="data-row">
            <label>Address:</label>
            <span
              >{{ facilityData.streetAddress }}, {{ facilityData.city }},
              {{ facilityData.state }} {{ facilityData.postcode }}</span
            >
          </div>
          <div class="data-row">
            <label>Practice Software:</label>
            <span>{{ facilityData.practiceSoftware }}</span>
          </div>
          <div class="data-row">
            <label>Referral Group:</label>
            <span>{{ facilityData.referralGroupName }}</span>
          </div>
        </div>
        <h4>Practice Manager</h4>
        <div class="data-grid">
          <div class="data-row">
            <label>Name:</label>
            <span>{{ facilityData.practiceManagerName }}</span>
          </div>
          <div class="data-row">
            <label>Email:</label>
            <span>{{ facilityData.practiceManagerEmail }}</span>
          </div>
          <div class="data-row">
            <label>Mobile:</label>
            <span>{{ facilityData.practiceManagerMobile }}</span>
          </div>
        </div>
        <h4>IT Technical Contact</h4>
        <div class="data-grid">
          <div class="data-row">
            <label>Name:</label>
            <span>{{ facilityData.itTechnicalName }}</span>
          </div>
          <div class="data-row">
            <label>Email:</label>
            <span>{{ facilityData.itTechnicalEmail }}</span>
          </div>
          <div class="data-row">
            <label>Mobile:</label>
            <span>{{ facilityData.itTechnicalMobile }}</span>
          </div>
        </div>
        <h4>Referral Group Requester</h4>
        <div class="data-grid">
          <div class="data-row">
            <label>Name:</label>
            <span>{{ facilityData.referralGroupRequesterName }}</span>
          </div>
          <div class="data-row">
            <label>Email:</label>
            <span>{{ facilityData.referralGroupRequesterEmail }}</span>
          </div>
          <div class="data-row">
            <label>Phone:</label>
            <span>{{ facilityData.referralGroupRequesterPhone }}</span>
          </div>
        </div>
      </div>
      <!-- Agreement Checkboxes -->
      <div class="agreements-section">
        <h3>Service Agreements</h3>
        <form [formGroup]="agreementForm">
          <!-- Privacy Policy Agreement -->
          <div class="agreement-item">
            <h4><span [innerHTML]="agreements.privacyPolicy.title"></span></h4>
            <mat-checkbox formControlName="agreePrivacyPolicy">
              <span [innerHTML]="agreements.privacyPolicy.text"></span>
            </mat-checkbox>
            @if (agreementForm.get('agreePrivacyPolicy')?.touched &&
            agreementForm.get('agreePrivacyPolicy')?.hasError('required')) {
            <div class="error-text">
              You must accept the Privacy Policy and Terms & Conditions
            </div>
            }
          </div>
          <!-- Medmate Terms Agreement -->
          <div class="agreement-item">
            <h4><span [innerHTML]="agreements.medmateTerms.title"></span></h4>
            <mat-checkbox formControlName="agreeMedmateTerms">
              <span [innerHTML]="agreements.medmateTerms.text"></span>
            </mat-checkbox>
            <!-- Medmate Terms Full Text (collapsible) -->
            <div class="agreement-full-text">
              <mat-expansion-panel class="medmate-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title>Read more</mat-panel-title>
                </mat-expansion-panel-header>
                <div
                  class="medmate-content"
                  [innerHTML]="agreements.medmateTerms.description"
                ></div>
              </mat-expansion-panel>
            </div>
            @if (agreementForm.get('agreeMedmateTerms')?.touched &&
            agreementForm.get('agreeMedmateTerms')?.hasError('required')) {
            <div class="error-text">You must accept the Medmate Terms and Conditions</div>
            }
          </div>
          <!-- EULA Agreement -->
          <div class="agreement-item">
            <h4>{{ agreements.eula.title }}</h4>
            <mat-checkbox formControlName="agreeEula">
              <span [innerHTML]="agreements.eula.text"></span>
            </mat-checkbox>
            <!-- EULA Full Text (collapsible) -->
            <div class="agreement-full-text">
              <mat-expansion-panel class="eula-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title>Read more</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="eula-content" [innerHTML]="agreements.eula.description"></div>
              </mat-expansion-panel>
            </div>
            @if (agreementForm.get('agreeEula')?.touched &&
            agreementForm.get('agreeEula')?.hasError('required')) {
            <div class="error-text">You must accept the EULA Agreement</div>
            }
          </div>
        </form>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="close()" [disabled]="isSubmitting">Cancel</button>
      <button
        mat-raised-button
        color="primary"
        (click)="onSubmitAgreements()"
        [disabled]="!allAgreementsAccepted || isSubmitting"
      >
        {{ isSubmitting ? 'Processing...' : 'Accept Agreement' }}
      </button>
    </mat-dialog-actions>
  </div>
  } @if (!showAgreementView) {
  <div>
    <mat-dialog-content class="dialog-content">
      <form [formGroup]="facilityForm" (ngSubmit)="onSave()">
        <!-- Facility ID -->
        @if (showFacilityId) {
        <mat-form-field appearance="outline" class="full-width mb-5">
          <mat-label>{{ getFieldLabel('facilityId') }}</mat-label>
          <input matInput formControlName="facilityId" [readonly]="facilityIdReadonly" />
        </mat-form-field>
        }
        <!-- Facility Name -->
        <mat-form-field appearance="outline" class="full-width mb-5">
          <mat-label>{{ getFieldLabel('facilityName') }}</mat-label>
          <input
            matInput
            formControlName="facilityName"
            [class.error]="
              facilityForm.get('facilityName')?.invalid &&
              facilityForm.get('facilityName')?.touched
            "
          />
          <mat-error>{{ getErrorMessage('facilityName') }}</mat-error>
        </mat-form-field>
        <!-- Address Fields -->
        <mat-form-field appearance="outline" class="full-width mb-5">
          <mat-label>{{ getFieldLabel('streetAddress') }}</mat-label>
          <input
            matInput
            formControlName="streetAddress"
            [class.error]="
              facilityForm.get('streetAddress')?.invalid &&
              facilityForm.get('streetAddress')?.touched
            "
          />
          <mat-error>{{ getErrorMessage('streetAddress') }}</mat-error>
        </mat-form-field>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>{{ getFieldLabel('city') }}</mat-label>
            <input
              matInput
              formControlName="city"
              [class.error]="
                facilityForm.get('city')?.invalid && facilityForm.get('city')?.touched
              "
            />
            <mat-error>{{ getErrorMessage('city') }}</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ getFieldLabel('state') }}</mat-label>
            <mat-select
              formControlName="state"
              [class.error]="
                facilityForm.get('state')?.invalid && facilityForm.get('state')?.touched
              "
            >
              <mat-option value="NSW">NSW</mat-option>
              <mat-option value="VIC">VIC</mat-option>
              <mat-option value="QLD">QLD</mat-option>
              <mat-option value="SA">SA</mat-option>
              <mat-option value="WA">WA</mat-option>
              <mat-option value="TAS">TAS</mat-option>
              <mat-option value="NT">NT</mat-option>
              <mat-option value="ACT">ACT</mat-option>
            </mat-select>
            <mat-error>{{ getErrorMessage('state') }}</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ getFieldLabel('postcode') }}</mat-label>
            <input
              matInput
              formControlName="postcode"
              [class.error]="
                facilityForm.get('postcode')?.invalid && facilityForm.get('postcode')?.touched
              "
            />
            <mat-error>{{ getErrorMessage('postcode') }}</mat-error>
          </mat-form-field>
        </div>
        @if (!data.isEdit) {
        <mat-form-field appearance="outline" class="full-width mt-5">
          <mat-label>Medical Clinic Email</mat-label>
          <input
            matInput
            formControlName="emails"
            placeholder="Enter emails separated by commas (e.g., email1@example.com, email2@example.com)"
            type="email"
          />
          <mat-icon matSuffix>email</mat-icon>
          <mat-hint class="mt-5">Separate multiple emails with commas</mat-hint>
          @if (facilityForm.get('emails')?.touched &&
          facilityForm.get('emails')?.hasError('invalidEmails')) {
          <mat-error> Please enter valid email addresses separated by commas </mat-error>
          }
        </mat-form-field>
        }
        <!-- Practice Software Selection -->
        <div class="practice-software-section mb-5">
          <h3 class="mt-7">Practice Software</h3>
          <div class="software-checkbox-blocks">
            @for (option of practiceSoftwareOptions; track option) {
            <div class="software-checkbox-block">
              <mat-checkbox
                [checked]="facilityForm.get('practiceSoftware')?.value === option.id"
                (change)="onPracticeSoftwareChange(option.id)"
              >
                @if (option.image) {
                <img [src]="option.image" [alt]="option.name" class="software-logo-checkbox" />
                }
                <span class="software-title-checkbox">{{ option.name }}</span>
              </mat-checkbox>
            </div>
            }
          </div>
          <!-- Custom Software Input -->
          @if (isCustomSoftware) {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Please specify your practice software</mat-label>
            <input matInput formControlName="practiceSoftwareCustom" />
            <mat-error>{{ getErrorMessage('practiceSoftwareCustom') }}</mat-error>
          </mat-form-field>
          }
        </div>
        <!-- Contact Information -->
        <div class="contact-section mb-5">
          <h3>Practice Manager</h3>
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>{{ getFieldLabel('practiceManagerName') }}</mat-label>
              <input
                matInput
                formControlName="practiceManagerName"
                [class.error]="
                  facilityForm.get('practiceManagerName')?.invalid &&
                  facilityForm.get('practiceManagerName')?.touched
                "
              />
              <mat-error>{{ getErrorMessage('practiceManagerName') }}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ getFieldLabel('practiceManagerEmail') }}</mat-label>
              <input
                matInput
                formControlName="practiceManagerEmail"
                type="email"
                [class.error]="
                  facilityForm.get('practiceManagerEmail')?.invalid &&
                  facilityForm.get('practiceManagerEmail')?.touched
                "
              />
              <mat-error>{{ getErrorMessage('practiceManagerEmail') }}</mat-error>
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ getFieldLabel('practiceManagerMobile') }}</mat-label>
            <input
              matInput
              formControlName="practiceManagerMobile"
              [class.error]="
                facilityForm.get('practiceManagerMobile')?.invalid &&
                facilityForm.get('practiceManagerMobile')?.touched
              "
            />
            <mat-error>{{ getErrorMessage('practiceManagerMobile') }}</mat-error>
          </mat-form-field>
          <h3>IT Technical Contact</h3>
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>{{ getFieldLabel('itTechnicalName') }}</mat-label>
              <input
                matInput
                formControlName="itTechnicalName"
                [class.error]="
                  facilityForm.get('itTechnicalName')?.invalid &&
                  facilityForm.get('itTechnicalName')?.touched
                "
              />
              <mat-error>{{ getErrorMessage('itTechnicalName') }}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ getFieldLabel('itTechnicalEmail') }}</mat-label>
              <input
                matInput
                formControlName="itTechnicalEmail"
                type="email"
                [class.error]="
                  facilityForm.get('itTechnicalEmail')?.invalid &&
                  facilityForm.get('itTechnicalEmail')?.touched
                "
              />
              <mat-error>{{ getErrorMessage('itTechnicalEmail') }}</mat-error>
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ getFieldLabel('itTechnicalMobile') }}</mat-label>
            <input
              matInput
              formControlName="itTechnicalMobile"
              [class.error]="
                facilityForm.get('itTechnicalMobile')?.invalid &&
                facilityForm.get('itTechnicalMobile')?.touched
              "
            />
            <mat-error>{{ getErrorMessage('itTechnicalMobile') }}</mat-error>
          </mat-form-field>
        </div>
        <!-- Referral Group Selection -->
        <div class="referral-group-section mb-5">
          <h3>Referral Group Requester</h3>
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Referral Group</mat-label>
              <mat-select formControlName="referralGroup" [disabled]="data.isRoleBasedUser">
                @for (group of data.referralGroups; track group) {
                <mat-option [value]="group.value">
                  {{ group.label }}
                </mat-option>
                }
              </mat-select>
              <mat-error>{{ getErrorMessage('referralGroup') }}</mat-error>
            </mat-form-field>
          </div>
          <!-- Imaging Centres Selection -->
          @if (facilityForm.get('referralGroup')?.value) {
          <div class="form-row">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Imaging Centres to receive e-Referrals</mat-label>
              <mat-select #performerIdsSelect formControlName="performer_ids" multiple>
                <!-- Select All Option -->
                <mat-option
                  [value]="'select_all'"
                  (click)="toggleSelectAll()"
                  [disabled]="performerIdsOptions.length === 0"
                  [selected]="isAllSelected()"
                >
                  Select all
                </mat-option>
                <!-- Normal Options -->
                @for (centre of performerIdsOptions; track centre) {
                <mat-option [value]="centre.id">
                  {{ centre.name }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Requester Name</mat-label>
              <input
                matInput
                formControlName="referralGroupRequesterName"
                [readonly]="data.isRoleBasedUser"
              />
              <mat-error>{{ getErrorMessage('referralGroupRequesterName') }}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input
                matInput
                formControlName="referralGroupRequesterEmail"
                type="email"
                [readonly]="data.isRoleBasedUser"
              />
              <mat-error>{{ getErrorMessage('referralGroupRequesterEmail') }}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Phone Number</mat-label>
              <input
                matInput
                formControlName="referralGroupRequesterPhone"
                [readonly]="data.isRoleBasedUser"
              />
              <mat-error>{{ getErrorMessage('referralGroupRequesterPhone') }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Account Manager Name</mat-label>
            <input
              matInput
              formControlName="accountManagerName"
              [readonly]="data.isRoleBasedUser"
            />
            <mat-error>{{ getErrorMessage('accountManagerName') }}</mat-error>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width mb-5">
            <mat-label>Notes</mat-label>
            <textarea
              matInput
              formControlName="notes"
              rows="3"
              placeholder="Add any notes here"
            ></textarea>
          </mat-form-field>
        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="close()" [disabled]="isSubmitting">Cancel</button>
      <button
        mat-raised-button
        color="primary"
        (click)="onSave()"
        [disabled]="!isFormValid() || isSubmitting"
      >
        {{ saveButtonText }}
      </button>
    </mat-dialog-actions>
  </div>
  }
</div>
